/// <reference path="../walkinManagerKiosk.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />


module Meevo.Plugins.WalkinManagerKiosk.Terms {

    class WimDisplayModalController {
        static $inject = [
            '$mdDialog',
            'meevo.components.busy.BusyService',
            'meevo.plugins.walkinManager.WalkinAppointmentService',
            'meevo.plugins.walkinManager.WalkInSettingsService'
        ];

        constructor(
            protected $mdDialog: ng.material.IDialogService,
            protected busyService: Meevo.Components.Busy.IBusyService,
            protected walkinAppointmentService: Meevo.Plugins.WalkinManager.IWalkinAppointmentService,
            protected walkInSettingsService: Meevo.Plugins.WalkinManager.IWalkInSettingsService
        ) {
            this.busyService.start();

            this.walkInSettingsService.fetchSettings()
                .then(() => {
                    this.getWalkInAppointments()
                        .finally(() => this.busyService.stop());
                })
                .catch(() => this.busyService.stop());
        };

        public ok(): void {
            this.$mdDialog.hide();
        }

        private getWalkInAppointments(): ng.IPromise<any> {
            return this.walkinAppointmentService.fetchWalkInAppointments(Meevo.Model.WaitListStatus.Default);
        }
    }

    angular.module('meevo.plugins.walkinManagerKiosk')
        .controller('meevo.plugins.walkinManagerKiosk.wimDisplay.WimDisplayModalController', WimDisplayModalController);
}
